import classNames from 'classnames';
import { Body } from 'copilot-design-system';
import Stripe from 'stripe';

import { BankCardIcon } from 'src/legacy/components/Icons';
import { BankVerifyActionProps } from 'src/legacy/components/PaymentMethodForm/BankVerifyButton';
import { PaymentSourceActions } from 'src/routes/billing/components/PaymentSourceActions';
import { white } from 'src/theme/colors';
import { StripePaymentMethod } from 'src/types/payment';
import {
  getCardLogo,
  getPaymentMethodDetailsFromSource,
  getPaymentNumberLabel,
} from 'src/utils/BillingUtils';

type PaymentMethodOptionProps = {
  source: StripePaymentMethod;
  isDefault: boolean;
  isSelected?: boolean;
  onMakeDefault: (source: StripePaymentMethod) => void;
  onDelete: (sourceId: string) => void;
  onSelect?: (sourceId: string) => void;
  bankAccount: Stripe.BankAccount | undefined;
} & Partial<BankVerifyActionProps>;

export const PaymentMethodOption = ({
  source,
  isDefault,
  isSelected = false,
  onSelect,
  onMakeDefault,
  onDelete,
  bankAccount,
  onVerify,
}: PaymentMethodOptionProps) => {
  const { card } = getPaymentMethodDetailsFromSource(source);

  return (
    <div
      className={classNames(
        'border-box h-12 px-3 flex items-center justify-between border border-solid rounded-4 my-3 hover:bg-[#F7F9FA] cursor-pointer',
        {
          ['border-primary']: isSelected,
          ['border-non-hover-border']: !isSelected,
        },
      )}
      onClick={() => onSelect && onSelect(source.id)}
    >
      <div className="flex items-center gap-2">
        {card ? (
          <img
            className="w-5"
            src={getCardLogo(card.brand, 'contained')}
            alt="card-logo"
          />
        ) : (
          <BankCardIcon style={{ fontSize: 20, color: white }} />
        )}
        <Body size="sm" className="text-black-heading">
          {getPaymentNumberLabel(source)}
        </Body>
      </div>
      <PaymentSourceActions
        source={source}
        bankAccount={bankAccount}
        onVerify={onVerify}
        isDefault={isDefault}
        onMakePrimaryMethod={onMakeDefault}
        onDeleteSource={onDelete}
      />
    </div>
  );
};
